"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpButton = exports.ItpButtonProps = void 0;
const lodash_1 = require("lodash");
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
require("./styles.scss");
const button_html_1 = __importDefault(require("./button.html"));
const validation_1 = require("../../validation");
const core_1 = require("@integro/core");
let ItpButtonProps = class ItpButtonProps extends vue_1.default {
    id;
    dropdownItem;
    dropdownStaysOpenOnClick;
    form;
    text;
    tooltip;
    icon;
    iconAppend;
    iconClass;
    spinText;
    spinning;
    spinnerType;
    type;
    size;
    variant;
    pill;
    squared;
    pressed;
    disabled;
    block;
    noWrap;
    noTab;
    href;
    useAuth;
    showSpinner;
    forceDownload;
    downloadFileName;
};
exports.ItpButtonProps = ItpButtonProps;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "dropdownItem", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "dropdownStaysOpenOnClick", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpButtonProps.prototype, "form", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "text", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "tooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "icon", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "iconAppend", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpButtonProps.prototype, "iconClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "spinText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "spinning", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'grow' }),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "spinnerType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'button' }),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "pill", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "squared", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "pressed", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "block", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "noWrap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "noTab", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpButtonProps.prototype, "href", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "useAuth", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "showSpinner", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpButtonProps.prototype, "forceDownload", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpButtonProps.prototype, "downloadFileName", void 0);
exports.ItpButtonProps = ItpButtonProps = __decorate([
    vue_property_decorator_1.Component
], ItpButtonProps);
let ItpButton = class ItpButton extends (0, vue_property_decorator_1.Mixins)(ItpButtonProps) {
    btnVariant;
    formInstance;
    isSpinning;
    onFormChange(newValue) {
        this.formInstance = (0, validation_1.isObservedForm)(newValue) ? newValue : null;
    }
    onVariantChange(newValue) {
        this.btnVariant = this.getVariant(newValue);
    }
    onSpinningChange(newValue) {
        this.isSpinning = newValue;
    }
    data() {
        return {
            formInstance: (0, validation_1.isObservedForm)(this.form) ? this.form : null,
            btnVariant: this.getVariant(this.variant),
            isSpinning: false
        };
    }
    getVariant(value) {
        return (value ||
            (this.type === 'submit'
                ? 'primary'
                : this.dropdownItem
                    ? 'default'
                    : 'light'));
    }
    getHref() {
        if ((0, lodash_1.isFunction)(this.href)) {
            return this.href();
        }
        return this.href;
    }
    getURL() {
        const href = this.getHref();
        return href ? core_1.downloads.normalizeLink(href) : null;
    }
    get tagName() {
        return this.dropdownItem ? 'b-dropdown-item' : 'b-button';
    }
    get formID() {
        if (this.formInstance != null) {
            return this.formInstance.id;
        }
        return this.form;
    }
    get buttonType() {
        return this.type;
    }
    get className() {
        return {
            'itp-button': true,
            'text-nowrap': this.noWrap,
            border: this.btnVariant === 'light' && !this.dropdownItem
        };
    }
    get isDisabled() {
        return (this.disabled ||
            this.isSpinning ||
            (this.formInstance && !this.formInstance.changed));
    }
    get formIcon() {
        if (!this.isSpinning && this.formInstance) {
            if (this.formInstance.changed) {
                return 'material-symbols:save';
            }
            return 'material-symbols:done';
        }
    }
    get bindings() {
        const result = {};
        if (this.noTab) {
            result['tabindex'] = '-1';
        }
        return result;
    }
    get bsIcon() {
        return this.icon && this.icon.startsWith('b-') && this.icon.substring(2);
    }
    get faIcon() {
        return this.icon && this.icon.startsWith('fa-') && `fas ${this.icon}`;
    }
    get iconifyIcon() {
        return (this.formIcon || (this.icon && (0, lodash_1.includes)(this.icon, ':') && this.icon));
    }
    get iconSpacer() {
        if (this.isSpinning) {
            return this.spinText ? 'mr-1' : '';
        }
        return this.text ? 'mr-1' : '';
    }
    get bsIconAppend() {
        return (this.iconAppend &&
            this.iconAppend.startsWith('b-') &&
            this.iconAppend.substring(2));
    }
    get faIconAppend() {
        return (this.iconAppend &&
            this.iconAppend.startsWith('fa-') &&
            `fas ${this.iconAppend}`);
    }
    get iconifyIconAppend() {
        return this.iconAppend && (0, lodash_1.includes)(this.iconAppend, ':') && this.iconAppend;
    }
    get iconSpacerAppend() {
        if (this.isSpinning) {
            return this.spinText ? 'ml-1' : '';
        }
        return this.text ? 'ml-1' : '';
    }
    onNativeClick(ev) {
        console.log('onNativeClick', ev);
        if (this.dropdownStaysOpenOnClick) {
            ev.stopPropagation();
            ev.preventDefault();
        }
    }
    onClick(ev) {
        console.log('onClick', ev);
        if (this.forceDownload) {
            return this.onDownloadClick(ev);
        }
        const url = this.getURL();
        if (this.useAuth && url) {
            ev.preventDefault();
            ev.stopPropagation();
            if (this.showSpinner) {
                this.isSpinning = true;
            }
            Promise.resolve(core_1.downloads.getFileBLOB(url))
                .then(p => {
                if (p) {
                    core_1.downloads.showFileInNewTab(p.file, p.fileName);
                    this.$emit('file', p);
                }
            })
                .finally(() => (this.isSpinning = false));
            return;
        }
        if (this.dropdownStaysOpenOnClick) {
            ev.stopPropagation();
            ev.preventDefault();
        }
        this.$emit('click', ev);
        if (this.formInstance != null && this.type == 'submit') {
            this.formInstance.requestSubmit();
        }
    }
    onDownloadClick(ev) {
        if (this.useAuth) {
            ev.preventDefault();
            const url = this.getURL();
            Promise.resolve(core_1.downloads.getFileBLOB(url, this.downloadFileName)).then(p => p && core_1.downloads.downloadFile(p.file, p.fileName));
        }
    }
};
exports.ItpButton = ItpButton;
__decorate([
    (0, vue_property_decorator_1.Watch)('form'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpButton.prototype, "onFormChange", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('variant'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpButton.prototype, "onVariantChange", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('spinning'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpButton.prototype, "onSpinningChange", null);
exports.ItpButton = ItpButton = __decorate([
    (0, vue_property_decorator_1.Component)({ template: button_html_1.default })
], ItpButton);
//# sourceMappingURL=button.js.map